module.exports = __webpack_public_path__ + "static/img/world_map@3x.5bca0b31.png";